/**
 * Marks any element that is a loading placeholder rather than real content.
 *
 * Skeletons render no text, so "wait until the loading copy is gone" no longer
 * distinguishes a pending table from a populated one. Tests (see
 * `waitForAccountsTable` in `e2e/fixtures.ts`) wait on this attribute instead.
 */
export const SKELETON_TEST_ID = 'loading-skeleton'

/**
 * Cycled placeholder widths. A uniform bar per cell reads as a solid block;
 * staggering the widths makes a skeleton scan like real content.
 */
const PLACEHOLDER_WIDTHS = ['w-full', 'w-3/4', 'w-1/2', 'w-5/6', 'w-2/3'] as const

/** Deterministic per-cell width so the skeleton doesn't shimmer-shift on re-render. */
export function placeholderWidth(row: number, column: number) {
  return PLACEHOLDER_WIDTHS[(row + column) % PLACEHOLDER_WIDTHS.length]
}
